import { Button } from "src/components";
import crossIcon from "../../../assets/cross.svg";

const round2 = (n: number) => Math.round(n * 100) / 100;

// Pack-equivalent of the order's fixed price for the invoice's pack, only when the packs are both
// known, differ, and a replaced product is involved; null otherwise (caller keeps the strict rule).
export const packEquivalentPrice = (invoiceLine: any, order: any): number | null => {
  const orderPack = Number(order?.per_strip);
  const invoicePack = Number(invoiceLine?.per_strip);
  const replaceInvolved =
    invoiceLine?.is_replaced || order?.is_replaced || (order?.replaced_products?.length ?? 0) > 0;
  if (!orderPack || !invoicePack || orderPack === invoicePack || !replaceInvolved) return null;
  return round2((Number(order?.fixed_price) / orderPack) * invoicePack);
};

// Confirms an invoice pack change (POST /invoice/pack-change plan.message) at Save Modified Data.
// Yes changes the order; the line itself is mapped afterwards via View.
const PerStripOrderEdit = ({
  message,
  onCloseModal,
  onConfirm,
  onDecline,
}: {
  message: string;
  onCloseModal: () => void;
  onConfirm: () => void;
  onDecline: () => void;
}) => (
  <div className="flex flex-col gap-y-2 w-[640px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
    <div className="flex justify-between items-center">
      <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Order Pack Change</p>
      <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
        <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
      </Button>
    </div>
    <p className="text-sm font-normal text-[#666666]">The supplied pack differs from the ordered pack.</p>
    <p className="text-sm font-normal text-[#1B1A1F]">{message}</p>
    <p className="text-sm font-normal text-[#666666]">
      This line is not mapped now. After the order is updated, click View and map it to that order.
    </p>
    <div className="flex justify-end gap-x-2">
      <Button className="text-white bg-[#8051FF] mt-4" onClick={onConfirm}>
        Yes
      </Button>
      <Button className="bg-[#f5f5f5] mt-4" onClick={onDecline}>
        No
      </Button>
    </div>
  </div>
);

export default PerStripOrderEdit;
